import type { ReactNode } from 'react';

export const symbol_woman: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M420-110v-190h-79q-15 0-24.5-12.5T312-339l90-289q8-25 30-38.5t48-13.5q26 0 48 13.5t30 38.5l90 289q5 14-4.5 26.5T619-300h-79v190q0 13-8.5 21.5T510-80h-60q-13 0-21.5-8.5T420-110Zm8.5-645.5Q407-777 407-807t21.5-51.5Q450-880 480-880t51.5 21.5Q553-837 553-807t-21.5 51.5Q510-734 480-734t-51.5-21.5Z"
		/>
	</svg>
);
